"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockConnector = void 0;
const faker_1 = require("@faker-js/faker");
const lodash_1 = require("lodash");
const common_1 = require("@hum/common");
const __1 = require("..");
const _1 = require("./");
const createMockConnector = (overwrites = {}) => {
    const configOverwrites = (0, lodash_1.omitBy)({
        connectorType: overwrites.connectorType,
        connectorSource: overwrites.connectorSource,
    }, lodash_1.isEmpty);
    return Object.assign({ id: faker_1.faker.datatype.number({ min: 1 }), companyId: faker_1.faker.datatype.number({ min: 1 }), connectorSource: (0, common_1.randomlySelectObjectValue)(__1.ConnectorSource), connectorType: (0, common_1.randomlySelectObjectValue)(__1.ConnectorType), createdAt: faker_1.faker.date.past().toISOString(), createdBy: faker_1.faker.datatype.number({ min: 1 }), dataPullInProgress: faker_1.faker.datatype.boolean(), healthStatus: (0, common_1.randomlySelectObjectValue)(__1.ConnectorHealthStatus), meta: {}, config: (0, _1.createMockConnectorConfig)(configOverwrites), status: (0, common_1.randomlySelectObjectValue)(__1.ConnectorStatus), tenants: [], updatedAt: faker_1.faker.date.past().toISOString() }, overwrites);
};
exports.createMockConnector = createMockConnector;
//# sourceMappingURL=Connector.factory.js.map